var _circle, _path, _rect, _circle2, _rect2, _circle3, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 5,
    r: 2,
    fill: "#2469EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3 5L4.2 5.9L5.7 4.3",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3,
    width: 10,
    height: 4,
    rx: 1,
    fill: "#2469EF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 10,
    r: 2,
    fill: "#E0E7FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8.5,
    width: 10,
    height: 4,
    rx: 1,
    fill: "#E0E7FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 15,
    r: 2,
    fill: "#E0E7FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 10,
    height: 4,
    rx: 1,
    fill: "#E0E7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceActive);
export default __webpack_public_path__ + "static/media/device-active.1ef4cf732cb9660fd6c902170eb62686.svg";
export { ForwardRef as ReactComponent };